import React, {ReactElement} from "react";
import {AppSettings} from "../../logic/APITypes";
import appSettingsLocal from "../../appsettings.LOCAL.json";

/**
 * Context that provide access to the app settings.
 */
export const AppSettingsContext =
  React.createContext<AppSettings>(appSettingsLocal);

function AppSettingsProvider({
  appSettings,
  children,
}: {
  appSettings: AppSettings;
  children: ReactElement;
}) {
  return (
    <AppSettingsContext.Provider value={appSettings}>
      {children}
    </AppSettingsContext.Provider>
  );
}

export default AppSettingsProvider;
